// extracted by mini-css-extract-plugin
export default {"wrapper":"OrganizationLandscapesPage_wrapper__uXus6"};